module.exports = __webpack_public_path__ + "img/un-battant.a4a8ae1.svg";